import React, { useState, useEffect, useRef } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import { InputTextarea } from 'primereact/inputtextarea';
import { Checkbox } from "primereact/checkbox";
import { parentsAPI } from '../../services/parentService';
import { transportAPI } from '../../services/transportService';
import { Label } from '@headlessui/react';

const TransportForm = ({ transportForm, editingTransport, handleCloseTransport, handleSaveTransport, loading, slabs, setTransportForm }) => {
  const [transportType, setTransportType] = useState(false);
  const [oneway, setOneway] = useState(false);
  const [twoway, setTwoway] = useState(false);


  const onClickOneway = (e) => {
    setOneway(e.checked);
    if (e.checked) {
      setTwoway(false)
    }
    setTransportType(transportForm.wayType);

  };
  const onClickTwoway = (e) => {
    setTwoway(e.checked);
    if (e.checked) {
      setOneway(false)
    }
     setTransportType(transportForm.wayType);
  };
 
  return (
    <Dialog header="Transport Form" visible={true} onHide={handleCloseTransport} style={{ width: '900px', textAlign: 'center' }} footer={(
      <div className="flex justify-between items-center mt-2">
        <Button label="Cancel" icon="pi pi-times" onClick={handleCloseTransport} disabled={loading} className="bg-black text-white rounded-lg px-4 py-2 hover:bg-gray-900 transition-all disabled:opacity-50 disabled:cursor-not-allowed" />
        <Button label={loading ? 'Loading' : (editingTransport ? 'Update' : 'Add')} icon="pi pi-plus" onClick={handleSaveTransport} loading={loading} className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white rounded-lg px-4 py-2 shadow-md hover:shadow-lg transition-all disabled:opacity-50 disabled:cursor-not-allowed" />
      </div>
    )}>
      <div className="space-y-6 p-2">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          <div className="space-y-2" >
            <h4>StudentName : </h4></div>
          <div className="space-y-2" >
            <InputText value={transportForm.firstName + ' ' + transportForm.lastName} readOnly
              required placeholder="Enter first name" />
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          <div className="space-y-2" >
            <h4>FatherName : </h4></div>
          <div className="space-y-2" >
            <InputText value={transportForm.parentName} readOnly
              required placeholder="Enter first name" />
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          <div className="space-y-2" >
            <h4>Class : </h4></div>
          <div className="space-y-2" >
            <InputText value={transportForm.className} readOnly
              required placeholder="Enter first name" />
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          <div className="space-y-2" >
            <h4>Section : </h4>
          </div>
          <div className="space-y-2" >
            <InputText value={transportForm.sectionName} readOnly
              required placeholder="Enter first name" />
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          <div className="space-y-2" >
            <h4> MobileNo : </h4></div>
          <div className="space-y-2" >
            <InputText value={transportForm.parentPhone} readOnly
              required placeholder="Enter first name" />
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          <div className="space-y-2" >
            <h4>Address : </h4></div>
          <div className="space-y-2" >
            <InputTextarea value={transportForm.parentAddress} readOnly
              required style={{ width: "300px", height: "130px" }} />
          </div>
        </div>
       
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          <div className="space-y-2" >
            <h4>TransportSlabs : </h4>
          </div>
          <div className="space-y-2" >
            <Dropdown value={transportForm.transportSlabId}  options={slabs.map(data=>({label:data.slabName, value:data.id}))}
                onChange={(e) => {
                  setTransportForm({ ...transportForm, transportSlabId: e.value })
                }}
              placeholder="Select Transport Slab" className="w-full" required />
          </div>
        </div>

      </div>

    </Dialog >
  );
};

export default TransportForm;
